import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Redirect from '@rad/components/utility/redirect';
import { useAuth } from '../../../hooks/useAuth';
import { landingRoutes, accountRoutes, paymentRoutes } from '../../../common/routes/general';
import NavLink from '../../../layout/components/nav-link';
import OwnedPropertiesPage from '../../owner/owned-properties';
import SavedPropertiesPage from '../../owner/saved-properties';
import OwnerVaultPage from '../../owner/owner-vault';
import ProfilePage from './profile';
import OrganizationsPage from './organizations';
import Membership from '../../../screens/general/membership';
const collapseClassNames = (xs) => xs.filter((x) => !!x).join(' ');
const collapseStyles = (xs) => xs.reduce((agg, x) => x ? Object.assign(Object.assign({}, agg), x) : agg, {});
const Container = (props) => {
    const classNames = collapseClassNames([
        'container',
        props.py && `py-${props.py}`,
    ]);
    const style = collapseStyles([
        props.width && { 'maxWidth': props.width }
    ]);
    return _jsx(_Fragment, { children: _jsx("div", { className: classNames, style: style, children: props.children }) });
};
export const tabs = {
    'my-properties': {
        'label': 'My Properties',
        'icon': 'bi-house-heart',
        'content': () => _jsx(OwnedPropertiesPage, {}),
        'criteria': () => true,
    },
    'saved': {
        'label': 'Saved',
        'icon': 'bi-heart',
        'content': () => _jsx(SavedPropertiesPage, {}),
        'criteria': () => true,
    },
    'owners-vault': {
        'label': 'Owner Vault',
        'icon': 'bi-folder',
        'content': (x) => x.isSubscribed() ? _jsx(Container, { py: 5, children: _jsx(OwnerVaultPage, {}) }) : _jsx(Redirect, { target: (paymentRoutes === null || paymentRoutes === void 0 ? void 0 : paymentRoutes.pricing.getURL()) || landingRoutes.root.getURL() }),
        'criteria': (x) => x.isSubscribed(), // TODO: access to files after subscription is cancelled+expires?
    },
    'membership': {
        'label': 'Membership',
        'icon': 'bi-stars',
        'content': (x) => x.isSubscribed() ? _jsx(Container, { py: 5, width: 960, children: _jsx(Membership, {}) }) : _jsx(Redirect, { target: (paymentRoutes === null || paymentRoutes === void 0 ? void 0 : paymentRoutes.pricing.getURL()) || landingRoutes.root.getURL() }),
        'criteria': (x) => x.isSubscribed(),
    },
    'organizations': {
        'label': 'Organizations',
        'icon': 'bi-buildings',
        'content': () => _jsx(Container, { py: 5, width: 960, children: _jsx(OrganizationsPage, {}) }),
        'criteria': () => true,
    },
    'profile': {
        'label': 'Profile',
        'icon': 'bi-person-circle',
        'content': () => _jsx(ProfilePage, {}),
        'criteria': () => true,
    },
};
const tabsArray = Object.entries(tabs);
const Account = (props) => {
    var _a, _b;
    const [auth] = useAuth();
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "border-bottom bg-white", children: _jsx("div", { className: "container-fluid", children: _jsx("ul", { className: "nav", children: tabsArray.map(([key, tab]) => !!tab && tab.criteria(auth) && _jsx(React.Fragment, { children: _jsx("li", { className: "nav-item", children: _jsx(NavLink, { item: { 'key': key, 'label': tab.label, 'icon': tab.icon, 'href': accountRoutes.account.getURL({ 'tab': key }) }, isActive: props.tab === tab, className: "py-3" }) }) }, key)) }) }) }), _jsxs("div", { className: "container-fluid py-4 px-4 bg-white", children: [_jsx("h5", { className: "fw-semibold mb-3", children: (_a = props.title) !== null && _a !== void 0 ? _a : props.tab.label }), (_b = props.children) !== null && _b !== void 0 ? _b : props.tab.content(auth)] })] }));
};
export default Account;
